import {Component} from "@angular/core";

@Component({
  selector: 'forbidden-error',
  standalone: true,
  templateUrl: './forbidden-error.component.html',
})
export class ForbiddenErrorComponent {}
